class ReferralTracking {

  constructor() {
    this.init();
  }

  init() {
    const referralCode = this.captureReferralCodeFromURL();
    if (referralCode) {
      console.debug(`[ReferralTracking] ✅ Código de referência capturado: ${referralCode}`);
      this.saveReferralCodeToLocalStorage(referralCode);
    }
  }

  captureReferralCodeFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const referralCode = urlParams.get('ref');
    if (referralCode) {
      return referralCode;
    }
    return null;
  }

  /**
   * @param {string} code - Referral code
   */
  async saveReferralCodeToLocalStorage(code) {
    const updates = {
      note: JSON.stringify({
        referralCode: code,
      }),
    };

    try {
      const response = await fetch(window.Theme.routes.cart_update_url + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updates),
      });
      
      if (response.ok) {
        const data = await response.json();
        console.info('[ReferralTracking] ✅ Cart note updated:', data);
      } else {
        throw new Error('Failed to update cart note');
      }
    } catch (error) {
      console.error('[ReferralTracking] ❌ Error updating cart note:', error);
    }
  }
}

(function() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      try {
        new ReferralTracking();
      } catch (error) {
        console.error('[ReferralTracking] ❌ Erro ao inicializar:', error);
      }
    });
  } else {
    try {
      new ReferralTracking();
    } catch (error) {
      console.error('[ReferralTracking] ❌ Erro ao inicializar:', error);
    }
  }
})();

